import { render, staticRenderFns } from "./DynamicFormFieldCheckbox.vue?vue&type=template&id=a06d03bc&"
import script from "./DynamicFormFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports